import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePriceComponents } from "@/components/Sections/Price/hooks/usePriceComponents";
import { PartnerBoxAds } from "@/components/Sections/Price/BuyView/PartnerBoxAds";
import { Section, Title } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useBrandContext } from "@/shared/contexts";
import { PARTNER_NAME } from "@/shared/types";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { PriceComponents } from "./PriceComponents";
import { PriceContainer } from "@/components/Sections/Price/PriceContainer";
import { PriceTotalCost } from "@/components/Sections/Price/PriceTotalCost/PriceTotalCost";
export const priceTestId = "cdp-price";
export const Price = () => {
    const components = usePriceComponents();
    const { priceRef } = useRefsContext();
    const modalPartner = useBrandContext().partnerService.find((service) => service.name === PARTNER_NAME.KFW);
    const { t } = useI18n();
    return (components === null || components === void 0 ? void 0 : components.length) ? (_jsxs(Section, { ref: priceRef, hasDivider: true, testId: priceTestId, children: [_jsx(Title, { variant: "section", title: t("price.title_buy_v2"), id: "price" }), _jsxs(Box, { display: "grid", gridTemplateColumns: {
                    "breakpoint.base": "repeat(1, 1fr)",
                    "breakpoint.md": "repeat(2, 1fr)",
                }, gap: "spacing.16", children: [_jsxs(Box, { gridColumn: {
                            "breakpoint.base": "1/1",
                            "breakpoint.md": "1/2",
                        }, children: [_jsx(PriceContainer, { children: _jsx(PriceComponents, {}) }), _jsx(PartnerBoxAds, { partner: modalPartner })] }), _jsx(Box, { gridColumn: {
                            "breakpoint.base": "1/1",
                            "breakpoint.md": "2/2",
                        }, children: _jsx(PriceTotalCost, {}) })] })] })) : null;
};
